// extracted by mini-css-extract-plugin
module.exports = {"albumContainer":"modals-PreviewsModal__albumContainer--ufCON","explanation":"modals-PreviewsModal__explanation--1x5AX","previewImage":"modals-PreviewsModal__previewImage--3kkt9"};